import Vue from 'vue'

const process_type = (val) => {
  try {
    var url = val.NODE_ENV,
      obj = {};
    switch (url) {
      case 'development':
        obj.importUrl = 'http://institutional.tougubang.net';
        obj.importUrl1 = 'http://pub.tougubang.net';
        obj.java_axiosUrl = 'http://testmt.tougub.com';
        obj.ruby1_axiosUrl = 'http://apvs.tougubang.net';
        obj.Domain = 'tougubang.net';
        obj.FRONT_BASE = 'http://jztest.jfinfo.com';
        break;
      case 'test':
        obj.importUrl = 'http://institutional.tougubang.net';
        obj.importUrl1 = 'http://pub.tougubang.net';
        obj.java_axiosUrl = 'http://testmt.tougub.com';
        obj.ruby1_axiosUrl = 'http://apvs.tougubang.net';
        obj.Domain = 'tougubang.net';
        obj.FRONT_BASE = 'http://jztest.jfinfo.com';
        break;
      case 'production':
        obj.importUrl = 'http://institutional.tougub.com';
        obj.importUrl1 = 'http://pub.tougub.com';
        obj.java_axiosUrl = 'http://mt.tougub.com';
        obj.ruby1_axiosUrl = 'http://apvs.tougub.com';
        obj.Domain = 'tougub.com';
        obj.FRONT_BASE = 'http://jz.jfinfo.com';
        break;
      default:
        obj.importUrl = 'http://institutional.tougubang.net';
        obj.importUrl1 = 'http://pub.tougubang.net';
        obj.java_axiosUrl = 'http://testmt.tougub.com';
        obj.ruby1_axiosUrl = 'http://apvs.tougubang.net';
        obj.Domain = 'tougubang.net';
        obj.FRONT_BASE = 'http://jztest.jfinfo.com';
    }
  } catch (e) {
    obj.importUrl = 'http://institutional.tougubang.net';
    obj.importUrl1 = 'http://pub.tougubang.net';
    obj.java_axiosUrl = 'http://testmt.tougub.com';
    obj.ruby1_axiosUrl = 'http://apvs.tougubang.net';
    obj.Domain = 'tougubang.net';
    obj.FRONT_BASE = 'http://jztest.jfinfo.com';
  }
  return obj;
}

export default process_type



// WEBPACK FOOTER //
// ./src/url_config.js